import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'global/lib/lodash';
import { UserPermission } from '../lib/filter';

const defaultNavOptions = { tasks: true, assessments: true, library: true };

export default (props) => {
  const accountSettings = useSelector((state) => get(state, 'auth.accountSettings'));
  const perms = useSelector((state) => get(state, 'auth.permissions'));
  const userCanAccessAgent = (perms || []).some((permission) => get(permission, 'name', '').indexOf('agent.access') > -1);
  const [nav, setNav] = useState({ ...defaultNavOptions, agent: userCanAccessAgent });

  const filterPermissionsByNav = () => {
    return UserPermission.filter((f) => {
      let n = get(f, 'nav');
      if (n) {
        if (typeof n === 'function') {
          return n(perms);
        }
        return !!get(nav, n);
      }

      return true;
    });
  };

  useEffect(() => {
    const asettings = (accountSettings || []).find((a) => get(a, 'name') === 'Nav Config');
    const configuredNav = JSON.parse(get(asettings, 'value', JSON.stringify({ ...defaultNavOptions, agent: userCanAccessAgent })));
    setNav({
      ...configuredNav,
      agent: userCanAccessAgent && get(configuredNav, 'agent', true),
    });

    //for testing
    // setNav({
    //   ...nav,
    //   tasks: false,
    //   // library: true,
    //   assessments: false,
    // })
  }, [accountSettings, userCanAccessAgent]);

  return {
    nav,
    filterPermissionsByNav,
  };
};
